const login = {
    existingUserEmail:false,
    isMissingPhone:null,
    noPackageOrEvent:null,
    isInactiveUser:null,
    existingEmailData:null
};

export default login;